import { AdmAPIList } from '@/api'

const api = new AdmAPIList();

export default {

  getAuthorizationList({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getAuthorizationList(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },

  getAuthorizationOption({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getAuthorizationOption(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },

  grantOrRevokeAuthorization({ state }, params) {
    return new Promise((resolve, reject) => {
      api.grantOrRevokeAuthorization(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/Adm/UserAuthorization/store/actions.js